import React from "react";
import { usePage, router } from "@inertiajs/react";
import { translations } from "../constants/translation";

const LandingLanguageContext = React.createContext(undefined);

export function LandingLanguageProvider({ children }) {
  const { locale } = usePage().props;
  const language = locale === "id" ? "id" : "en";
  const t = translations[language].landing;

  const switchLocale = (newLocale) => {
    const path = window.location.pathname;
    // Strip any existing /id prefix to get the locale-agnostic path, then re-add
    // it for Indonesian. Works for every marketing route (/hebe, /insights, ...).
    const bare = path.startsWith("/id/")
      ? path.slice(3)
      : path === "/id"
        ? "/"
        : path;
    if (newLocale === "id") {
      router.visit(bare === "/" ? "/id" : `/id${bare}`);
    } else {
      router.visit(bare);
    }
  };

  const value = React.useMemo(
    () => ({ language, t, switchLocale }),
    [language, t],
  );

  return (
    <LandingLanguageContext.Provider value={value}>
      {children}
    </LandingLanguageContext.Provider>
  );
}

export function useLandingLanguage() {
  const ctx = React.use(LandingLanguageContext);
  if (ctx === undefined) {
    throw new Error(
      "useLandingLanguage must be used within LandingLanguageProvider",
    );
  }
  return ctx;
}
